<app-job-pointe-list [tableData]="data" [source]="data.type"> </app-job-pointe-list>
